import React, { useState } from "react"
import { withI18n } from "~/hocs"
import { NextPage } from "next"
import { AppCommonProps } from "types/app"
import {
  Modal,
  Button,
  Row,
  Col,
  Form,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDownload } from "@fortawesome/free-solid-svg-icons"
import config from "~/config"
import { FormatByte } from "~/components/common"

const DLModal: NextPage<AppCommonProps> = ({
  show,
  onHide,
  videoStocks,
  onChange,
  value,
  setValue,
  handleDownloadFile,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleDL = () => {
    setIsLoading(true)
    try {
      handleDownloadFile()
      setTimeout(() => {
        onHide() 
        setIsLoading(false)
      }, 1000)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modal-download-video"
    >
      <Modal.Body>
        <h5 className="mb-4">形式を選択してください</h5>
        <div className="text-center">
          <Row>
            {videoStocks.slice(0, 3).map((item: any, idx: number) => {
              const resolutions = {
                1: {
                  id: 1,
                  name: "モバイル（S）",
                  price: -1,
                  isPremium: false,
                  tooltipHover: "SD / 360p",
                },
                2: {
                  id: 2,
                  name: "モバイル（L）",
                  price: -1,
                  isPremium: false,
                  tooltipHover: "SD / 540p",
                },
                3: {
                  id: 3,
                  name: "HD",
                  price: -1,
                  isPremium: false,
                  tooltipHover: "ハイビジョン / 720p",
                },
              }

              const type = resolutions[item.type_id]

              return (
                <Col key={idx} style={{padding: 0}}>
                  <div
                    className={`${idx === 0 ? "border-left" : ""} border-right`}
                  >
                    <Form.Check
                      defaultChecked={idx === value}
                      onClick={onChange}
                      type="radio"
                      id={`download-${idx}`}
                      name="download"
                      value={idx}
                      label={
                        <div>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-${idx}`}>
                                {type.tooltipHover}
                              </Tooltip>
                            }
                          >
                            <span
                              className="font-weight-bold cursor-pointer"
                              style={{ display: "inline-block" }}
                            >
                              {type.name}
                            </span>
                          </OverlayTrigger>
                        </div>
                      }
                    />
                    <p className="text-center mb-0">
                      <small>
                        <FormatByte value={item.size} />
                      </small>
                    </p>
                    <p className="text-center mb-0">
                      <small>
                        {item.width} x {item.height}px
                      </small>
                    </p>
                  </div>
                </Col>
              )
            })}
          </Row>
          <div
            className="text-center mt-3"
            style={{ color: "#1C74B3" }}
            onClick={handleDL}
          >
            {/* <span className="text-decoration-none ac-btn-md ac-btn-photo w-100 justify-content-center custom-shadow historyDowloads">
                            <FontAwesomeIcon icon={faDownload} className="mr-2" />
                            ダウンロード
                        </span> */}
            <Button
              type="button"
              disabled={isLoading}
              className="text-decoration-none ac-btn-md ac-btn-photo w-100 justify-content-center custom-shadow historyDowloads"
            >
              {isLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              <FontAwesomeIcon icon={faDownload} className="mr-2" />
              ダウンロード
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default withI18n(DLModal)
